import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PipesModule } from 'src/app/shared/pipe/pipe.module';
import { ComplementsFooterComponent } from './complements-footer.component';
import { FooterListComponent } from './footer-list/footer-list.component';

@NgModule({
    imports: [CommonModule, TranslateModule, PipesModule],
    declarations: [ComplementsFooterComponent, FooterListComponent],
    exports: [ComplementsFooterComponent],
})
export class ComplementsFooterModule {}
